<template>
  <div style="max-width:900px; margin: auto;">
      <br />
      <h2>Remote Scoreboard Access</h2>
   <hr />
   <br />
   <div class="seasoncast-card">
       <p>
           Edit stats in real-time with secondary devices using LockerStats.com or GameBee.io. Get pin by opening scoreboard editor on the broadcast device. On the top right is the event pin. You can also locate it by going to the event in the dashboard then clicking 'Remote Scoreboard'. GameBee is our legacy stat editor. LockerStats is a fully featured team stats. Both are free to use. 
           </p>
            <br />
            <a href="https://lockerstats.com" target="_blank" class="btn btn-dark">Go to LockerStats</a>
           <br /> <br />
            <a href="https://gamebee.io" target="_blank" class="btn btn-success">Open GameBee.io</a>
            
   </div>
   <br />

</div>
</template>
<script>


export default {
  name: 'RemoteScoreboard',
  components: {
    
  }
}
  </script>